import { Component } from '@angular/core';

@Component({
    selector: 'teller-online-icon-select-payment',
    templateUrl: '../svgs/Wallet.svg',
    host: {
        class: 'teller-online-icon teller-online-icon--select-payment'
    },
    standalone: false
})
export class TellerOnlineIconSelectPayment {
}
